import React, { Component, Fragment } from 'react';
import SelectInput from 'components/Select';
import CustomInput from 'components/InputValidation';
import noImage from 'assets/no_img.svg';

class CustomfitEdit extends Component {
    constructor(props) {
      super(props);
      this.state={
        mealType:props.mealType || '',
        catId:props.catId || '',
        dishId:props.dishId || { value: '0', label: "None" },
        qty:props.qty || 0
      }
    }
    componentWillReceiveProps(next){
        if((next.dishId.value!=this.props.dishId.value)||(next.qty!=this.props.qty)){
            this.setState({dishId:next.dishId,qty:next.qty});
        }
    }
    renderAddMeals(){ 
        const { name, catId, dishList, dish, changeDefaultValues, mealType, errors, calculateMacros } = this.props;
        const { dishId, qty } = this.state;
        const dishNone = {'0':'None'};
        const listDish = (name=='Protein')?dishList:{...dishNone,...dishList};
        let labelText = `Select ${name}`;
        let dishVal=(dishId&&dish[dishId.value]!=undefined)?dish[dishId.value]:{};
        let basePrice =(dishVal.base_price>0)?(dishVal.base_price/100):0;
        let price =("base_price" in dishVal)? basePrice+((qty/100)*(dishVal.price/100)):0;
        const unit=(name=='Sauce')?'PC':'Gram';
        return <Fragment>
            <div className={'col-12'}  style={{marginBottom:'10px'}}>
                  <div className={'select_div'}>
                    <p className={'body-subhead'}>{name}</p>
                    <p className={'body-subhead-small'}>Select {name} & Cooked Weight</p>
                  </div>
              </div>
              <div className={'col-12'}>
                <div className={'dishtype-options'}>
                     <SelectInput
                        placeholder={labelText}
                        list={listDish || {}}
                        value={dishId}
                        name="selectdish"
                        onChange={ (name, val) => {
                            this.setState({ dishId: val,qty:(val.value==0)?0:qty},changeDefaultValues(catId,mealType,'dishId',val.value));
                        }}
                    />
                         
                  {errors!='' &&<div className={'col-12'}><p style={{ fontSize: 'small',textAlign:'left',position:'relative',top:"0",color:'#d57669' }} customColor='#f44336'>{errors}</p></div>}
                  <CustomInput
                        placeholder={`Select Cooked Weight ${unit}`}
                        value={qty || 0}
                        type='number'
                        name='qty'
                        onChange={(name,val) => {
                            let qtyVal=val;
                            if(unit=='Gram' && qtyVal>400){
                              qtyVal=400;
                              alert('Please enter quantity less than or equal to 400 Grams');
                            }else if(unit=='PC' && qtyVal>4){
                              qtyVal=4;
                              alert('Please enter quantity less than or equal to 4 PC');
                            }
                            this.setState({ qty:qtyVal  },changeDefaultValues(catId,mealType,'qty',qtyVal))}}
                    />
                </div>
            </div>      
                <div className={'customfit-edit-bottom col-12'} style={{marginBottom:'10px'}}>
                  <p className="dish_price">{price.toFixed(2)} AED</p>
                  <p className='dish_cals'>{calculateMacros((dishVal.calories/1000),qty) || 0} Kcal  |  {calculateMacros((dishVal.protein/1000),qty) || 0}g Protein  |  {calculateMacros((dishVal.carb/1000),qty) || 0}g Carbs  |  {calculateMacros((dishVal.fat/1000),qty) || 0}g Fat</p>
              </div>
        </Fragment>;
    }

    renderEditMeals(){
      const { name, catId, dishList, dish, changeDefaultValues, mealType, errors,calculateMacros } = this.props;
      const { dishId, qty } = this.state;
      const dishNone = {'0':'None'};
      const listDish = (name=='Protein')?dishList:{...dishNone,...dishList};
      let labelText = `Select ${name}`;
      let dishVal=(dishId&&dish[dishId.value]!=undefined)?dish[dishId.value]:{};
      let basePrice =(dishVal.base_price>0)?(dishVal.base_price/100):0;
      let price =("base_price" in dishVal)? basePrice+((qty/100)*(dishVal.price/100)):0;
      const { image } = dishVal || {};
      const imgUrl = image ? `${image}` : noImage;
      const unit=(name=='Sauce')?'PC':'Gram';
      return <Fragment>
            <div className={'col-12'}  style={{marginBottom:'10px'}}>
                  <p className='dish_label' style={{ fontSize: 'large',textAlign:'center' }} customColor='#555'>{name}</p>
                  <div className="img-holder d-card-img">
                      <div className="image_click ">
                          <img src={imgUrl} /> 
                      </div>
                  </div>
              </div>
              <div className={'col-12'}>
                <div className={'dishtype-options'}>
                        <SelectInput
                            placeholder={labelText}
                            list={listDish || {}}
                            value={dishId}
                            name="selectdish"
                            onChange={ (name, val) => {
                                this.setState({ dishId: val,qty:(val.value==0)?0:qty },changeDefaultValues(catId,mealType,'dishId',val.value));
                            }}
                        />                                
                    {errors!='' &&<div className={'col-12'}><p style={{ fontSize: 'small',textAlign:'left',position:'relative',top:"0",color:'#d57669' }} customColor='#f44336'>{errors}</p></div>}
                    <CustomInput
                            placeholder={`Select Cooked Weight ${unit}`}
                            value={qty || 0}
                            type='number'
                            name='qty'
                            onChange={(name,val) => {   let qtyVal=val;
                              if(catId==1  && qtyVal<=0){
                                alert('Please enter value greater than zero');
                                qtyVal=qty;
                              }
                                if(unit=='Gram' && qtyVal>400){
                                  qtyVal=400;
                                  alert('Please enter quantity less than or equal to 400 Grams');
                                }else if(unit=='PC' && qtyVal>4){
                                  qtyVal=4;
                                  alert('Please enter quantity less than or equal to 4 PC');
                                }
                                this.setState({ qty:qtyVal  },changeDefaultValues(catId,mealType,'qty',qtyVal))}}
                        />
                </div>   
            </div>
                <div className={'customfit-edit-bottom col-12'} style={{marginBottom:'10px'}}>
                  <p style={{ textAlign:'center', marginLeft:'10px' }} customColor='#555'>{calculateMacros((dishVal.calories/1000),qty) || 0} Kcal  |  {calculateMacros((dishVal.protein/1000),qty) || 0}g Protein  |  {calculateMacros((dishVal.carb/1000),qty) || 0}g Carbs  |  {calculateMacros((dishVal.fat/1000),qty) || 0}g Fat</p>
                  <p className="bold" style={{ fontSize: 'large',textAlign:'center' }} customColor='#555'>{price.toFixed(2)} AED</p>
              </div>
        </Fragment>;
    }
    render(){
      const { isEdit } = this.props;
      return <div item className={'customfit-edit-row'}>
            {isEdit && this.renderEditMeals()}
            {!isEdit && this.renderAddMeals()}
      </div>;
    }
}  
export default CustomfitEdit;